/* istanbul ignore file */

import { Text } from 'pcln-design-system'
import PropTypes from 'prop-types'
import React from 'react'
import { StyledRedesignButton } from './DepartureSummary.styles'

export const ChangeButton = ({ changeFlightHandler, size }) => (
  <StyledRedesignButton
    size={size}
    data-test-id='change-flight-button-top'
    onClick={changeFlightHandler}
    aria-label='change-flight-button'
    color={'background.lightest'}
  >
    <Text color={'primary.base'} borderRadius='xl' fontSize={0} fontWeight='bold'>
      Change Flight
    </Text>
  </StyledRedesignButton>
)

ChangeButton.propTypes = {
  /** Change Handler for on Click */
  changeFlightHandler: PropTypes.func,

  /** Breakpoint array for size */
  size: PropTypes.array,
}
